// extracted by mini-css-extract-plugin
module.exports = {"root":"_3HXuP","list":"_2zNTD","expanded":"_2WuRK","showMoreWrapper":"_1MtLO","showMore":"_2D1gE"};